<template>
    <div class="login_container">
        <div style="position: absolute;left: 50%;top: 15%;transform: translate(-50%, -50%);color: white;font-size: 36px"> {{$t('common.admin')}}</div>
        <div style="position: absolute;left: 65%;top: 95%;color: white;font-size: 16px">Copyright  2010-2022 成都正图科技有限公司  All Rights Reserved</div>
        <div class="login_box">
            <!--头像区域-->
            <div class="avatar_box">
                <img src="../assets/logo2.jpg">
            </div>
            <!--&lt;!&ndash;二维码&ndash;&gt;-->
            <!--<div style="float: left">-->
                <!--<div class="qrcode" ref="qrCodeUrl" >-->

                <!--</div>-->
                <!--<div class="qrcode1"  @click="xzApp">-->
                    <!--点击下载糖份检测APP-->
                <!--</div>-->
            <!--</div>-->
            <div style="float: left;">
                <div class="qrcode" ref="qrCodeUrl" >

                </div>
                <div class="qrcode1"  @click="xzApp">
                    {{$t('common.app')}}
                </div>
            </div>
            <!--登录表单区域-->
            <el-form ref="loginFormRef" label-width="0px" class="login_form" :model="loginForm" :rules="loginFormRules">
                <!--用户名区域-->
                <el-form-item prop="username">
                    <el-input prefix-icon="el-icon-user" placeholder="请输入用户名/手机号/邮箱" v-model="loginForm.username"
                              type="text"></el-input>
                </el-form-item>
                <!--密码区域-->
                <el-form-item prop="password">
                    <el-input prefix-icon="el-icon-lock" v-model="loginForm.password" type="password"
                              @keyup.enter.native="login" placeholder="请输入密码"></el-input>
                </el-form-item>
                <!--按钮区域-->
                <el-form-item class="btns">
                    <el-button type="primary" @click="login">{{$t('common.login')}}</el-button>
                    <el-button type="primary" @click="register">{{$t('common.register')}}</el-button>
                    <el-button type="primary" @click="resetPassword">{{$t('common.password')}}</el-button>
                    <el-button type="info" @click="resetLoginForm">{{$t('common.reset')}}</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import QRCode from 'qrcodejs2'
    export default {
        name: 'zhengtusensorLogin',
        data() {
            return {
                appUrl1:'',
                showadd:true,
                appUrl:'',
                // 登录表单的数据绑定对象
                loginForm: {},
                // 表单的验证规则对象
                loginFormRules: {
                    // 验证用户名是否合法
                    username: [
                        {required: true, message: '请输入用户名', trigger: 'blur'},
                        {min: 5, max: 20, message: '长度在 5 到 20 个字符', trigger: 'blur'}
                    ],
                    // 验证密码是否合法
                    password: [
                        {required: true, message: '请输入密码', trigger: 'blur'},
                        {min: 5, max: 15, message: '长度在 5 到 15 个字符', trigger: 'blur'}
                    ]
                }
            }
        },
        mounted() {
            this.getappUrl()
            this.getappUrl1()
        },
        methods: {
            xzApp(){
                window.location.href=this.appUrl
            },
            xzApp1(){
                window.location.href=this.appUrl1
            },
            async getappUrl(){
                const {data: res} = await this.$http.post(`/appedition/selectUpTimeT`, {});

                this.appUrl = res.data.versionsUrl
                this.creatQrCode();
            },
            async getappUrl1(){
                // const {data: res} = await this.$http.post(`/appedition/selectUpTimeJ`, {});
                //
                // this.appUrl1 = res.data.versionsUrl
                // this.creatQrCode1();
            },
            // 生成糖份二维码
            creatQrCode() {
                var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                    text: this.appUrl, // 需要转换为二维码的内容
                    width: 150,
                    height: 150,
                    colorDark: "#000000",//二维码颜色
                    colorLight: "#ffffff",//二维码的背景色
                    correctLevel: QRCode.CorrectLevel.H//容错率，L/M/H
                });
            },
            // 生成路面检测二维码
            creatQrCode1() {
                var qrcode = new QRCode(this.$refs.qrCodeUrl1, {
                    text: this.appUrl1, // 需要转换为二维码的内容
                    width: 200,
                    height: 200,
                    colorDark: "#000000",//二维码颜色
                    colorLight: "#ffffff",//二维码的背景色
                    correctLevel: QRCode.CorrectLevel.H//容错率，L/M/H
                });
            },
            // 点击重设按钮，重设登录表单
            resetLoginForm() {
                this.$refs['loginFormRef'].resetFields()
            },
            login() {
                this.$refs.loginFormRef.validate(async valid => {
                    if (!valid) return;
                    this.loginForm.adminType="userT"
                    let {data: res} = await this.$http.post('/login', this.loginForm);
                    if (res.code !== 1) {
                        this.$message.error(res.msg)
                    } else {
                        this.$message.success('登录成功');
                        window.sessionStorage.setItem('Authorization', res.data.Authorization);
                        window.sessionStorage.setItem("RoleId",res.data.role_id)
                        window.sessionStorage.setItem("userId",res.data.userId)
                        window.sessionStorage.setItem("type","userT")
                        window.sessionStorage.setItem("username",res.data.username)
                        await this.$router.push('/home')
                    }
                })
            },
            register() {
                this.$router.push('/register')
            }
            ,
            resetPassword() {
                this.$router.push('/resetPassword')
            }
        }
    }
</script>

<style lang="less" scoped>
    .login_container {
        background-image: url(../assets/2.png);
        height: 100%;
        background-repeat: no-repeat;
        background-size:cover;
    }

    .login_box {
        width: 450px;
        height: 300px;
        background-color: #fff;
        border-radius: 3px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);

        .avatar_box {
            height: 130px;
            width: 130px;
            border: 1px solid #eee;
            border-radius: 50%;
            padding: 10px;
            box-shadow: 0 0 10px #ddd;
            position: absolute;
            left: 50%;
            transform: translate(-50%, -50%);
            background-color: #fff;

            img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
                background-color: #eee;
            }
        }
    }
    .qrcode{
        height: 150px;
        width: 150px;
        /*border: 1px solid #eee;*/
        /*border-radius: 50%;*/
        /*padding: 10px;*/
        /*box-shadow: 0 0 10px #ddd;*/
        position: absolute;
        margin-left: 33%;
        margin-top: 75%;
    }
    .qrcode1{
        cursor:pointer;
        height: 20px;
        width: 160px;
        text-align: center;
        /*border: 1px solid #eee;*/
        /*border-radius: 50%;*/
        /*padding: 10px;*/
        /*box-shadow: 0 0 10px #ddd;*/
        position: absolute;
        margin-left: 32%;
        margin-top: 110%;
        color: white;
    }
    .btns {
        display: flex;
        justify-content: flex-end;
    }

    .login_form {
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;
    }
</style>
